export const oldTeamsiteContent_PENNSYLVANIACOUNTYLISTNOONXPRODUCTS = {
  displayingWarning: true,
  displayCountyName: true,
  counties: [
    'Lycoming',
    'Adams',
    'Centre',
    'Columbia',
    'Fulton',
    'Juniata',
    'Lebanon',
    'Mifflin',
    'Montour',
    'Northumberland',
    'Snyder',
    'Union',
    'York',
    'Armstrong',
    'Bedford',
    'Cameron',
    'Centre',
    'Clarion',
    'Clearfield',
    'Elk',
    'Fayette',
    'Forest',
    'Greene',
    'Huntingdon',
    'Indiana',
    'Jefferson',
    'Lawrence',
    'McKean',
    'Mercer',
    'Potter',
    'Warren',
    'Venango'
  ]
};

export const applicationStatusWY = {
  elementNames: {
    elementOne: 'Date of Last Activity',
    elementTwo: 'Effective Date',
    elementThree: 'Coverage ZIP Code',
    elementFour: 'County',
    elementFive: 'Status Details'
  },
  statuses: [
    {
      id: 5,
      description: 'New Customer',
      details:
        "<p class='statusContent'>Blue Cross Blue Shield of Wyoming is presently updating its coverage options for this region.  Please check back with us soon.</p><p class='statusContent'>Need Help? Give us a call.</p><p class='statusContent'>Monday - Friday<br/>(8:00 am to 8:00 pm EST)<br/>Saturday and Sunday<br/>(10:00 am to 4:00 pm EST)<br/><p>(TTY/TDD: 800-696-4710)</p>",
      CPA: "<p class='statusContent'>In Central PA: 1-855-329-1761</p>",
      WPA: "<p class='statusContent'>In Western PA: 1-855-329-1760</p>",
      NEPA: "<p class='statusContent'>In Northeastern PA: 1-855-856-0317</p>",
      DE: "<p class='statusContent'>In Delaware: 1-855-329-1764</p>",
      WV: "<p class='statusContent'>In West Virginia: 1-855-329-1763</p>",
      extraContent:
        "<p class='statusContent'>Prefer face-to-face help?</p><p class='statusContent'>Stop by a Blue Cross Blue Shield of Wyoming Direct store.  Speak with one of our experienced customer service representatives for personalized service.  We have 10 locations in Pennsylvania.</p><p class='statusContent'>All Blue Cross Blue Shield of Wyoming Direct stores offer over-the-phone translation services in Spanish and 49 other languages.</p><p class='statusContent'>Sign language interpreters are also available upon appointment.</p>",
      buttons: {
        shopHighmark: false,
        continueToMarketplace: false,
        printSummary: false,
        makePayment: false,
        goToMarketplace: false,
        viewResults: false,
        moreInfo: false,
        goToHealthSherpa: false
      }
    },
    {
      id: 6,
      description: 'New Customer',
      details:
        '<p>Continue with your application to the Health Insurance Marketplace. </p><p>Need assistance?</p><p>Monday-Friday</p><p>8:00 am - 5:00 pm</p><p>800-851-2227</p><br /><p>(TTY/TDD: 800-696-4710)</p>',
      CPA: '<p>In Central PA: 1-855-329-1761</p>',
      WPA: '<p>In Western PA: 1-855-329-1760</p>',
      NEPA: '<p>In Northeastern PA: 1-855-856-0317</p>',
      DE: '<p>In Delaware: 1-855-329-1764</p>',
      WV: '<p>In West Virginia: 1-855-329-1763</p>',
      buttons: {
        shopHighmark: false,
        continueToMarketplace: false,
        printSummary: false,
        makePayment: false,
        goToMarketplace: true,
        viewResults: false,
        moreInfo: false,
        goToHealthSherpa: false
      }
    },
    {
      id: 7,
      description: 'Exception on Eligibility Application',
      details:
        '<p>It looks like there is an error in determining your eligibility.  Return to the Health Insurance Marketplace to resolve this issue, or continue to shop directly with Blue Cross Blue Shield of Wyoming.</p><br /><p>Plans purchased directly from Blue Cross Blue Shield of Wyoming are not eligible for the Advanced Premium Tax Credit (APTC) and/or Cost-Sharing Reduction (CSR).',
      buttons: {
        shopHighmark: true,
        continueToMarketplace: false,
        printSummary: false,
        makePayment: false,
        goToMarketplace: true,
        viewResults: false,
        moreInfo: false,
        goToHealthSherpa: false
      }
    },
    {
      id: 8,
      description: 'User Initiated Return',
      details:
        '<p>You have returned without completing your Health Insurance Marketplace eligibility application. To continue, select Go To the Marketplace. Or, you can Shop Directly with Blue Cross Blue Shield of Wyoming.</p><br /><p>Plans purchased directly from Blue Cross Blue Shield of Wyoming are not eligible for the Advanced Premium Tax Credit (APTC) and/or Cost-Sharing Reduction (CSR).',
      buttons: {
        shopHighmark: true,
        continueToMarketplace: false,
        printSummary: false,
        makePayment: false,
        goToMarketplace: true,
        viewResults: false,
        moreInfo: false,
        goToHealthSherpa: false
      }
    },
    {
      id: 9,
      description: 'Completed Eligibility Application',
      details:
        "<p>View your Marketplace application results to find out if you're eligible for an Advanced Premium Tax Credit (APTC) and/or Cost-Sharing Reduction (CSR) to help with your health insurance costs.</p><br /> <p>Need assistance?</p><p>Monday-Friday</p><p>8:00 am - 5:00 pm</p><p>800-851-2227</p><br /><p>(TTY/TDD: 800-696-4710)</p>",
      CPA: '<p>In Central PA: 1-855-329-1761</p>',
      WPA: '<p>In Western PA: 1-855-329-1760</p>',
      NEPA: '<p>In Northeastern PA: 1-855-856-0317</p>',
      DE: '<p>In Delaware: 1-855-329-1764</p>',
      WV: '<p>In West Virginia: 1-855-329-1763</p>',
      buttons: {
        shopHighmark: false,
        continueToMarketplace: false,
        printSummary: false,
        makePayment: false,
        goToMarketplace: true,
        viewResults: true,
        moreInfo: false,
        goToHealthSherpa: false
      }
    },
    {
      id: 10,
      description: 'Shop Directly With Blue Cross Blue Shield of Wyoming',
      details:
        "<p>Remember: Plans purchased directly from Blue Cross Blue Shield of Wyoming are not eligible for the Advanced Premium Tax Credit (APTC) and/or Cost-Sharing Reduction (CSR).  These savings may only be applied to plans purchased through the Health Insurance Marketplace.</p><br /><p>Do you want to continue shopping in the Marketplace?  You'll find many plans from the Blue Cross Blue Shield of Wyoming family of brands there.</p>",
      buttons: {
        shopHighmark: false,
        continueToMarketplace: true,
        printSummary: false,
        makePayment: false,
        goToMarketplace: false,
        viewResults: false,
        moreInfo: false,
        goToHealthSherpa: false
      }
    },
    {
      id: 11,
      description: 'Enrollment Application Submission Failed',
      details:
        "<p>We're sorry. Enrollment cannot be completed at this time.  In order to proceed, Go To the Marketplace and retrieve eligibility to try again.</p>",
      buttons: {
        shopHighmark: false,
        continueToMarketplace: false,
        printSummary: false,
        makePayment: false,
        goToMarketplace: true,
        viewResults: false,
        moreInfo: false,
        goToHealthSherpa: false
      }
    },
    {
      id: 12,
      description: 'Enrollment Application Was Submitted',
      details:
        "<p>Make a payment now.</p><br /><p>If no payment is made, you will be billed and the first month's premium must be received by the payment due date.  If the payment is not received by the due date, the enrollment will be cancelled.</p>",
      buttons: {
        shopHighmark: false,
        continueToMarketplace: false,
        printSummary: false,
        makePayment: true,
        goToMarketplace: false,
        viewResults: false,
        moreInfo: true,
        goToHealthSherpa: false
      }
    },
    {
      id: 13,
      description: 'Enrollment Application Complete',
      details:
        '<p>Thank you!  Your payment has been successfully submitted.  Please be sure to print an enrollment summary for your records.</p>',
      buttons: {
        shopHighmark: false,
        continueToMarketplace: false,
        printSummary: true,
        makePayment: false,
        goToMarketplace: false,
        viewResults: false,
        moreInfo: false,
        goToHealthSherpa: false
      }
    },
    {
      id: 14,
      description: 'Enrollment Application Complete (Send Me a Bill)',
      details:
        '<p>The application has been successfully submitted.</p><br /><p>Please be sure to print a summary for your records.</p><br /><p>You can choose to make a payment now or wait for a bill to arrive. Because you selected "Send Me a Bill," coverage will not begin until payment is received for the full amount of the first month\'s premium.  If payment is not received by the requested due date, this plan may be cancelled.</p>',
      buttons: {
        shopHighmark: false,
        continueToMarketplace: false,
        printSummary: true,
        makePayment: true,
        goToMarketplace: false,
        viewResults: false,
        moreInfo: true,
        goToHealthSherpa: false
      }
    },
    {
      id: 15,
      description: 'Enrollment Application Was Submitted(Payment Past Due)',
      details:
        '<p>No payment was submitted with this online application.</p><br /><p>Information displayed here does not reflect any payment made outside of this online application.</p><br/><p>Click <b>More Info</b> to see more information and options.</p>',
      buttons: {
        shopHighmark: false,
        continueToMarketplace: false,
        printSummary: false,
        makePayment: false,
        goToMarketplace: false,
        viewResults: false,
        moreInfo: true,
        goToHealthSherpa: false
      }
    },
    {
      id: 16,
      description:
        'Enrollment Application Complete (Send Me a Bill)(payment Past Due)',
      details:
        '<p>No payment was submitted with this online application.</p><br /><p>Information displayed here does not reflect any payment made outside of this online application.</p><br/><p>Click <b>More Info</b> to see more information and options.</p>',
      buttons: {
        shopHighmark: false,
        continueToMarketplace: false,
        printSummary: true,
        makePayment: false,
        goToMarketplace: false,
        viewResults: false,
        moreInfo: true,
        goToHealthSherpa: false
      }
    }
  ]
};

export const applicationStatusND = {
  leftNav: {
    id: 'marketplace-sidebar',
    sidebarLoadedId: 'marketplace-sidebar-Loaded',
    desktopHeadlineText: 'APPLICATION STATUS',
    sectionTitle: 'REVIEW ELIGIBILITY APPLICATION RESULTS',
    sectionHomeHref: '#!/marketplace/application-status',
    subText:
      'Track the status of your application to the Health Insurance Marketplace',
    forceReload: true,
    mobileOnly: false,
    links: [
      {
        linkId: 'applicationStatus-sbLink',
        linkHref: '#!/marketplace/application-status',
        linkTitle: 'Marketplace application status',
        linkText: 'Marketplace application status'
      }
    ]
  },
  content: {
    noONXProductsWarningContent:
      '<i><p>Blue Cross Blue Shield of North Dakota does not offer any plans through the Marketplace in the county you selected. To view all plans offered through the Marketplace in the county you selected, please visit <a href="https://www.healthcare.gov/" target="_blank" rel="noopener noreferrer">www.healthcare.gov</a>.  To purchase a plan directly with Blue Cross Blue Shield of North Dakota, please close this window and choose Shop Directly with BCBSND.  However, please note that subsidies (Advanced Premium Tax Credits and Cost-Sharing Reductions) <b>CANNOT</b> be used with plans purchased directly with BCBSND.  If you qualify for a subsidy and would like to use it, please visit the Marketplace at <a href="https://www.healthcare.gov/" target="_blank" rel="noopener noreferrer">www.healthcare.gov</a>.</p></i><br/><hr/>',
    modalContent:
      "<p>You are about to visit the Health Insurance Marketplace</p><p>You'll need some information. Here's a handy checklist:</p><br /><p><ul class='applicationStatus'><li>Employer and income information for everyone in your family. For example: paystubs, W-2 forms, or wage and tax statements</li><li>Social Security numbers (or document numbers for legal immigrants)</li><li>Birthdates for everyone for whom you are applying</li><li>Policy numbers for any current health insurance</li><li>Information about any job-related health insurance available to your family</li><li>Tribe name if you or a family member are American Indian or Alaska Native</li></ul></p><br /><p>If you're having problems viewing the Health Insurance Marketplace, your Web browser might not be compatible.<br />Visit the Browser Compatibility section on healthcare.gov to see which browsers work best with the Health Insurance Marketplace.</p><br /><hr />",
    modalContentExtended:
      "<strong class='h4'>Legal</strong><br />This website contains links to third-party websites and resources (collectively, \"Linked Sites\").  These Linked Sites are provided solely as a convenience to you and not as an endorsement by Blue Cross Blue Shield of North Dakota of the content on such Linked Sites. Blue Cross Blue Shield of North Dakota makes no representations or warranties regarding the correctness, accuracy, performance or quality of any content, software, service or application found at any Linked Site. Blue Cross Blue Shield of North Dakota is not responsible for the availability of the Linked Sites or the content or activities of such sites. If you decide to access Linked Sites, you do so at your own risk. In addition, your use of Linked Sites is subject to any applicable policies and terms and conditions of use, including but not limited to, the Linked Site's privacy and security policy.",
    moreInfoContent:
      '<p>To see if a payment has been made, and to find out what options you may</p><p>have available, or any action you may need to take, call 1-888-510-1084  DEFAULT</p><p>Monday through Friday, 8:00 a.m. - 8:00 p.m.  (TTY/TDD: 711)</p>'
  },
  headline: 'MARKETPLACE APPLICATION STATUS',
  elementNames: {
    elementOne: 'Date of Last Activity',
    elementTwo: 'Effective Date',
    elementThree: 'Coverage ZIP Code',
    elementFour: 'County',
    elementFive: 'Status Details'
  },
  statusButtons: {
    shopDirectButton: 'Shop Directly with BCBSND',
    continueMarketplaceButton: 'Continue to the Marketplace',
    printButton: 'Print',
    makePaymentButton: 'Make Payment',
    marketplaceButton: 'Go to Marketplace',
    viewResultsButton: 'View Results',
    moreInfoButton: 'More Info'
  },
  statuses: [
    {
      id: 5,
      description: 'New Customer',
      details:
        "<p class='statusContent'>BCBSND is presently updating its coverage options for this region.  Please check back with us soon.</p>Need Help? Give us a call at 800-280-2583</p>Monday - Friday<br/>(8 a.m. to 4:30 p.m. CST)<br/>",
      CPA: '',
      WPA: '',
      NEPA: '',
      DE: '',
      WV: '',
      extraContent: '',
      buttons: {
        shopHighmark: false,
        continueToMarketplace: false,
        printSummary: false,
        makePayment: false,
        goToMarketplace: false,
        viewResults: false,
        moreInfo: false
      }
    },
    {
      id: 6,
      description: 'New Customer',
      details:
        '<p>Continue with your application to the Health Insurance Marketplace. </p><p>Need assistance? Call BCBSND at 800-280-2583</p><p>Monday-Friday</p><p>8 a.m. - 4:30 p.m. CST</p>',
      CPA: '',
      WPA: '',
      NEPA: '',
      DE: '',
      WV: '',
      buttons: {
        shopHighmark: false,
        continueToMarketplace: false,
        printSummary: false,
        makePayment: false,
        goToMarketplace: true,
        viewResults: false,
        moreInfo: false
      }
    },
    {
      id: 7,
      description: 'Exception on Eligibility Application',
      details:
        '<p>It looks like there is an error in determining your eligibility.  Return to the Health Insurance Marketplace to resolve this issue, or continue to shop directly with BCBSND.</p><br /><p>Plans purchased directly from BCBSND are not eligible for the Advanced Premium Tax Credit (APTC) and/or Cost-Sharing Reduction (CSR).',
      buttons: {
        shopHighmark: true,
        continueToMarketplace: false,
        printSummary: false,
        makePayment: false,
        goToMarketplace: true,
        viewResults: false,
        moreInfo: false
      }
    },
    {
      id: 8,
      description: 'User Initiated Return',
      details:
        '<p>You have returned without completing your Health Insurance Marketplace eligibility application. To continue, select Go To the Marketplace. Or, you can Shop Directly with BCBSND.</p><br /><p>Plans purchased directly from BCBSND are not eligible for the Advanced Premium Tax Credit (APTC) and/or Cost-Sharing Reduction (CSR).',
      buttons: {
        shopHighmark: true,
        continueToMarketplace: false,
        printSummary: false,
        makePayment: false,
        goToMarketplace: true,
        viewResults: false,
        moreInfo: false
      }
    },
    {
      id: 9,
      description: 'Completed Eligibility Application',
      details:
        "<p>View your Marketplace application results to find out if you're eligible for an Advanced Premium Tax Credit (APTC) and/or Cost-Sharing Reduction (CSR) to help with your health insurance costs.</p><br /> <p>If you have any questions, please contact BCBSND:<br>800-280-2583<br> Monday through Friday, 8 a.m. &#45; 4:30 p.m. CST (TTY/TDD:711)</p>",
      CPA: '',
      WPA: '',
      NEPA: '',
      DE: '',
      WV: '',
      buttons: {
        shopHighmark: false,
        continueToMarketplace: false,
        printSummary: false,
        makePayment: false,
        goToMarketplace: true,
        viewResults: true,
        moreInfo: false
      }
    },
    {
      id: 10,
      description: 'Shop Directly With BCBSND',
      details:
        "<p>Remember: Plans purchased directly from BCBSND are not eligible for the Advanced Premium Tax Credit (APTC) and/or Cost-Sharing Reduction (CSR).  These savings may only be applied to plans purchased through the Health Insurance Marketplace.</p><br /><p>Do you want to continue shopping in the Marketplace?  You'll find many plans from the BCBSND family of brands there.</p>",
      buttons: {
        shopHighmark: false,
        continueToMarketplace: true,
        printSummary: false,
        makePayment: false,
        goToMarketplace: false,
        viewResults: false,
        moreInfo: false
      }
    },
    {
      id: 11,
      description: 'Enrollment Application Submission Failed',
      details:
        "<p>We're sorry. Enrollment cannot be completed at this time.  In order to proceed, Go To the Marketplace and retrieve eligibility to try again.</p>",
      buttons: {
        shopHighmark: false,
        continueToMarketplace: false,
        printSummary: false,
        makePayment: false,
        goToMarketplace: true,
        viewResults: false,
        moreInfo: false
      }
    },
    {
      id: 12,
      description: 'Enrollment Application Was Submitted',
      details:
        "<p>Make a payment now.</p><br /><p>If no payment is made, you will be billed and the first month's premium must be received by the payment due date.  If the payment is not received by the due date, the enrollment will be cancelled.</p>",
      buttons: {
        shopHighmark: false,
        continueToMarketplace: false,
        printSummary: false,
        makePayment: true,
        goToMarketplace: false,
        viewResults: false,
        moreInfo: true
      }
    },
    {
      id: 13,
      description: 'Enrollment Application Complete',
      details:
        '<p>Thank you!  Your payment has been successfully submitted.  Please be sure to print an enrollment summary for your records.</p>',
      buttons: {
        shopHighmark: false,
        continueToMarketplace: false,
        printSummary: true,
        makePayment: false,
        goToMarketplace: false,
        viewResults: false,
        moreInfo: false
      }
    },
    {
      id: 14,
      description: 'Enrollment Application Complete (Send Me a Bill)',
      details:
        '<p>The application has been successfully submitted.</p><br /><p>Please be sure to print a summary for your records.</p><br /><p>You can choose to make a payment now or wait for a bill to arrive. Because you selected "Send Me a Bill," coverage will not begin until payment is received for the full amount of the first month\'s premium.  If payment is not received by the requested due date, this plan may be cancelled.</p>',
      buttons: {
        shopHighmark: false,
        continueToMarketplace: false,
        printSummary: true,
        makePayment: true,
        goToMarketplace: false,
        viewResults: false,
        moreInfo: true
      }
    },
    {
      id: 15,
      description: 'Enrollment Application Was Submitted(Payment Past Due)',
      details:
        '<p>No payment was submitted with this online application.</p><br /><p>Information displayed here does not reflect any payment made outside of this online application.</p><br/><p>Click <b>More Info</b> to see more information and options.</p>',
      buttons: {
        shopHighmark: false,
        continueToMarketplace: false,
        printSummary: false,
        makePayment: false,
        goToMarketplace: false,
        viewResults: false,
        moreInfo: true
      }
    },
    {
      id: 16,
      description:
        'Enrollment Application Complete (Send Me a Bill)(payment Past Due)',
      details:
        '<p>No payment was submitted with this online application.</p><br /><p>Information displayed here does not reflect any payment made outside of this online application.</p><br/><p>Click <b>More Info</b> to see more information and options.</p>',
      buttons: {
        shopHighmark: false,
        continueToMarketplace: false,
        printSummary: true,
        makePayment: false,
        goToMarketplace: false,
        viewResults: false,
        moreInfo: true
      }
    }
  ]
};
